import { Component } from '@angular/core';

import { UpgradesPanelComponent } from '@echospaces-web-monorepo/es-portal-ecms';

/**
 * Standalone admin route for schema-upgrade management. Wraps the
 * `UpgradesPanelComponent` from es-ecms — kept as a thin adapter so the
 * admin section owns its own routing surface while the panel itself
 * stays where the UpgradeService lives.
 */
@Component({
  selector: 'es-admin-upgrades-page',
  imports: [UpgradesPanelComponent],
  template: `
    <div class="max-w-4xl mx-auto">
      <div class="mb-6">
        <h1 class="text-2xl font-bold font-exo">Updates</h1>
        <p class="text-sm text-[var(--text-secondary)]">
          Pending schema upgrades for your organization.
        </p>
      </div>
      <es-upgrades-panel></es-upgrades-panel>
    </div>
  `,
})
export class AdminUpgradesPageComponent {}
